import { Camera } from 'lucide-react'
import { cn } from '@/src/utils/styles'
import { Badge } from '../ui/badge'
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog'
import { AVATARS, type Avatar, AvatarImage } from './avatar'

interface AvatarDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  currentAvatar?: Avatar
  onAvatarSelect: (avatar: Avatar) => void
}

export function AvatarDialog({
  isOpen,
  onOpenChange,
  currentAvatar,
  onAvatarSelect,
}: AvatarDialogProps) {
  const handleAvatarClick = (avatar: Avatar) => {
    onAvatarSelect(avatar)
    onOpenChange(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby='choose avatar'
        className='sm:max-w-[28rem] h-auto min-h-[unset]'
        showCloseButton
        showBackButton={false}
        middle={
          <DialogTitle className='text-xl font-semibold text-primary'>
            Choose an avatar
          </DialogTitle>
        }
      >
        {/* Avatar Grid */}
        <div className='grid grid-cols-3 mb-8 p-8 pt-0'>
          {AVATARS.map((avatar) => (
            <button
              key={avatar}
              onClick={() => handleAvatarClick(avatar)}
              disabled={currentAvatar === avatar}
              className={cn(
                'relative rounded-full overflow-hidden p-2 w-28 h-28 transition-all opacity-40 hover:opacity-100 duration-200 hover:scale-105',
                currentAvatar === avatar && 'opacity-100',
              )}
              style={{
                boxShadow:
                  currentAvatar === avatar
                    ? 'inset 0 0 0 2px var(--accent-primary)'
                    : undefined,
              }}
            >
              <AvatarImage
                avatar={avatar}
                size={96}
                className='w-full h-full object-cover'
              />
            </button>
          ))}

          {/* Custom Avatar Option */}
          <div className='relative group w-24 h-24 m-2 rounded-full border-2 border-dashed border-border1 flex items-center justify-center'>
            <div className='flex flex-col items-center gap-1 group-hover:opacity-40'>
              <Camera size={32} className='text-border2' />
              <span className='text-xs text-tertiary'>Upload</span>
            </div>

            <Badge className='absolute top-1/2 whitespace-nowrap left-1/2 transform -translate-x-1/2 group-hover:-translate-y-1/2 opacity-0 group-hover:opacity-100 bg-surface2-100 transition'>
              Coming soon
            </Badge>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
